const hydrateErrors = (errors, setError) => {
  Object.keys(errors).forEach((fieldName) => {
    errors[fieldName].forEach((errorMessage) => {
      setError(fieldName, { type: "custom", message: errorMessage });
    });
  });
};

export { hydrateErrors };
